<template>
  <div class="createPost">
    <div class="createPostHeader">
      <div class="headerContainer">
        <h1 class="containerTitle">ثبت پروژه</h1>
        <div class="containerBackBtn" @click="historyBackHandler">
          <i class="fas fa-arrow-left"></i>
        </div>
      </div>
    </div>
    <div v-if="dataLoading" class="createPostMain">
      <div class="mainContainer">
        <div class="containerForm">
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <Skeletor class="titleSk" />
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup categoryGroup skeltonWrapper">
                <Skeletor class="inputSk" />
              </div>
            </form>
          </div>
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <Skeletor class="titleSk" />
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup categoryGroup skeltonWrapper">
                <Skeletor class="inputSk" />
              </div>
            </form>
          </div>
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <Skeletor class="titleSk" />
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup categoryGroup skeltonWrapper">
                <Skeletor class="textAreaSk" />
              </div>
            </form>
          </div>
          <div class="containerSection">
            <Skeletor class="containerSectionSk" />
          </div>
        </div>
        <div class="containerSubmitSection">
          <div class="containerCancel" @click="historyBackHandler">
            <i class="fas fa-arrow-right"></i>
            بازگشت
          </div>
          <div
            v-if="!loading && !editPost"
            class="containerSubmit"
            @click="submitPostHandler"
          >
            ثبت پروژه
            <i class="fas fa-check"></i>
          </div>
          <div
            v-if="!loading && editPost"
            class="containerSubmit"
            @click="editPostHandler"
          >
            ویرایش پروژه
            <i class="fas fa-check"></i>
          </div>
          <div v-if="loading" class="containerSubmit">
            <span class="myLoader"></span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!dataLoading" class="createPostMain">
      <div v-show="step == 1" class="mainContainer">
        <div class="containerForm">
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fas fa-edit"></span>
                <span>نام پروژه<span>*</span></span>
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup categoryGroup">
                <input
                  type="text"
                  v-model="post_filds.content"
                  class="groupTextInput"
                />
              </div>
            </form>
          </div>
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fas fa-tasks"></span>
                <span>وضعیت پروژه<span>*</span></span>
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup categoryGroup">
                <el-select
                  class="formSelectInput"
                  v-model="post_filds.status"
                  placeholder=""
                >
                  <el-option value="done" label="تحویل شده"> </el-option>
                  <el-option value="building" label="درحال ساخت"> </el-option>
                  <el-option value="pre_sale" label="پیش فروش"> </el-option>
                </el-select>
              </div>
            </form>
          </div>
          <!-- <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fa-solid fa-layer-group"></span>
                <span>تعداد طبقات</span>
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup categoryGroup">
                <el-select
                  class="formSelectInput"
                  v-model="post_filds.total_floor"
                  placeholder=""
                >
                  <el-option :value="0" :label="'بدون طبقه'"></el-option>
                  <el-option
                    v-for="i in 10"
                    :key="i"
                    :value="i"
                    :label="`${i} طبقه`"
                  >
                  </el-option>
                  <el-option :value="11" :label="'بیش از 10 طبقه'">
                  </el-option>
                </el-select>
              </div>
            </form>
          </div> -->
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fas fa-align-right"></span>
                <span>توضیحات</span>
              </div>
            </div>
            <form class="sectionForm">
              <div class="formGroup">
                <textarea
                  class="groupTextarea"
                  maxlength="550"
                  v-model="post_filds.details"
                ></textarea>
                <div class="textLength">
                  {{ post_filds.details.length }}/550
                </div>
              </div>
            </form>
          </div>
          <div class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fas fa-map-marker-alt"></span>
                <span>موقعیت مکانی <span>*</span></span>
              </div>
            </div>
            <form class="sectionForm">
              <div class="mapGroup">
                <div id="map" class="leaflet-map"></div>
                <div class="mapAddressInput">
                  <input
                    type="text"
                    class="addressInput"
                    v-model="post_filds.address"
                    placeholder="آدرس را وارد کنید"
                  />
                </div>
              </div>
            </form>
          </div>
          <div v-if="!editPost" class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fas fa-images"></span>
                <span>آپلود تصاویر <span>*</span></span>
              </div>
            </div>
            <div class="sectionMain">
              <div class="formPicUploadWrapper">
                <input
                  type="file"
                  id="uploadImage"
                  multiple
                  accept="image/*"
                  @change="handleFileChange"
                  class="file-input"
                />
                <div class="picUploadForm">
                  <div
                    class="uploadFormContent"
                    for="uploadImage"
                    @dragover.prevent
                    @drop.prevent="handleDrop"
                  >
                    <div class="contentHeader">
                      <div class="uploadPic">
                        <i
                          class="fas fa-cloud-upload-alt text-4xl text-gray-400"
                        ></i>
                      </div>
                    </div>
                    <div class="contentMain">
                      <div class="mainDesc">تصاویر را اینجا بنداز</div>
                      <div class="mainSubtitle">یا</div>
                    </div>
                    <label for="uploadImage" class="contentFooter">
                      <div class="uploadBtn">افزودن تصویر</div>
                    </label>
                  </div>
                </div>
                <div class="picUploadedWrapper">
                  <label for="uploadImage" class="mobileUploadForm">
                    <div class="formIcon">
                      <i class="fas fa-plus"></i>
                    </div>
                    <div class="formTitle">افزودن عکس</div>
                  </label>
                  <!-- <div
                    class="uploadedThumb noUploadedThumb"
                    v-if="front_show.images.length === 0"
                  >
                    <div class="thumbPic">
                      <div class="noUploadPic">
                        <i class="fas fa-image"></i>
                        <p>تصویری آپلود نشد</p>
                      </div>
                    </div>
                    <div class="thumbContent">
                      <div class="contentBtn editBtn">
                        <div class="btnIcon">
                          <i class="fas fa-pencil-alt"></i>
                        </div>
                      </div>
                      <div class="contentBtn deleteBtn">
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div
                    class="uploadedThumb"
                    v-for="(image, index) in front_show.images"
                    :key="index"
                  >
                    <div class="thumbPic">
                      <img :src="image" alt="Preview" class="preview-image" />
                    </div>
                    <div class="thumbContent">
                      <div
                        class="contentBtn editBtn"
                        @click="setEditIndex(index)"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-pencil-alt"></i>
                        </div>
                      </div>
                      <div
                        class="contentBtn deleteBtn"
                        @click="removeImage(index)"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="editPost" class="containerSection">
            <div class="sectionHeader">
              <div class="headerTitle">
                <span class="fas fa-images"></span>
                <span>آپلود تصاویر</span>
              </div>
            </div>
            <div class="sectionMain">
              <div class="formPicUploadWrapper">
                <input
                  type="file"
                  id="uploadImage"
                  multiple
                  accept="image/*"
                  @change="editHandleFileChange"
                  class="file-input"
                />
                <div class="picUploadForm">
                  <div
                    class="uploadFormContent"
                    for="uploadImage"
                    @dragover.prevent
                    @drop.prevent="editHandleDrop"
                  >
                    <div class="contentHeader">
                      <div class="uploadPic">
                        <i
                          class="fas fa-cloud-upload-alt text-4xl text-gray-400"
                        ></i>
                      </div>
                    </div>
                    <div class="contentMain">
                      <div class="mainDesc">تصاویر را اینجا بنداز</div>
                      <div class="mainSubtitle">یا</div>
                    </div>
                    <label for="uploadImage" class="contentFooter">
                      <div class="uploadBtn">افزودن تصویر</div>
                    </label>
                  </div>
                </div>
                <div class="picUploadedWrapper">
                  <label for="uploadImage" class="mobileUploadForm">
                    <div class="formIcon">
                      <i class="fas fa-plus"></i>
                    </div>
                    <div class="formTitle">افزودن عکس</div>
                  </label>
                  <div
                    class="uploadedThumb noUploadedThumb"
                    v-if="front_show.images.length === 0"
                  >
                    <div class="thumbPic">
                      <div class="noUploadPic">
                        <i class="fas fa-image"></i>
                        <p>تصویری آپلود نشد</p>
                      </div>
                    </div>
                    <div class="thumbContent">
                      <div class="contentBtn editBtn">
                        <div class="btnIcon">
                          <i class="fas fa-pencil-alt"></i>
                        </div>
                      </div>
                      <div class="contentBtn deleteBtn">
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="uploadedThumb"
                    v-for="(image, index) in front_show.images"
                    :key="index"
                  >
                    <div class="thumbPic">
                      <img :src="image" alt="Preview" class="preview-image" />
                    </div>
                    <div class="thumbContent">
                      <div
                        class="contentBtn editBtn"
                        @click="editSetEditIndex(index)"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-pencil-alt"></i>
                        </div>
                      </div>
                      <div
                        class="contentBtn deleteBtn"
                        @click="editRemoveImage(index)"
                      >
                        <div class="btnIcon">
                          <i class="fas fa-trash-alt"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="containerSubmitSection">
          <div class="containerCancel"  @click="historyBackHandler">
            <i class="fas fa-arrow-right"></i>
            بازگشت
          </div>
          <div
            v-if="!loading && !editPost"
            class="containerSubmit"
            @click="submitPostHandler"
          >
            ثبت پروژه
            <i class="fas fa-check"></i>
          </div>
          <div
            v-if="!loading && editPost"
            class="containerSubmit"
            @click="editPostHandler"
          >
            ویرایش پروژه
            <i class="fas fa-check"></i>
          </div>
          <div v-if="loading" class="containerSubmit">
            <span class="myLoader"></span>
          </div>
        </div>
      </div>
      <div class="mainFormStep fourthStep" v-if="step == 2">
        <div class="successedMessageWrapper">
          <div class="messageThumb">
            <div class="thumbHeader">
              <div class="successedIcon">
                <i class="fas fa-check"></i>
              </div>
            </div>
            <div class="thumbMain">
              <div class="mainTitle">پروژه شما با موفقیت ثبت شد!</div>
              <div class="mainSubtitle">
                پروژه شما ثبت شد و در لیست پروژه‌ها قابل مشاهده می‌باشد.
              </div>
            </div>
            <div class="thumbFooter">
              <div class="footerButtonWrapper">
                <button
                  type="button"
                  class="footerButton btnBack reAddButton"
                  @click="newMelkHandler"
                >
                  <div class="btnTitle">ثبت پروژه جدید</div>
                </button>
                <button
                  type="button"
                  class="footerButton btnShow"
                  @click="showListHandler"
                >
                  <div class="btnTitle">مشاهده لیست</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Compressor from "compressorjs";
import { toast } from "vue3-toastify";
import axios from "axios";
import { Skeletor } from "vue-skeletor";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

export default {
  name: "builderCreatePost",
  components: { Skeletor },
  data() {
    return {
      step: 1,
      loading: false,
      editIndex: null,
      post_filds: {
        status: "",
        images: [],
        details: "",
        content: "",
        total_floor: "",
        latitude: null,
        longitude: null,
        address: null,
      },
      front_show: {
        images: [],
      },
      dataLoaded: false,
      editPost: false,
      dataLoading: false,
      map: null,
      marker: null,
      searchQuery: "",
      defaultCenter: [36.5663854, 52.6707147],
      defaultZoom: 14,
    };
  },
  methods: {
    showListHandler() {
      this.$router.push("/user-profile/my-projects");
    },
    newMelkHandler() {
      this.step = 1;
    },
    handleFileChange(event) {
      let self = this;
      const files = event.target.files;

      const files_length = files.length + self.front_show.images.length;
      if (files_length > 8) {
        toast("شما حداکثر مجاز به بارگذاری 8 تصویر می باشید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }

      if (this.editIndex !== null) {
        const file = files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            self.front_show.images[this.editIndex] = e.target.result;
            self.editIndex = null;
          };
          reader.readAsDataURL(file);

          new Compressor(file, {
            quality: 0.6,

            success(result) {
              self.post_filds.images[this.editIndex] = result;
            },
            error(err) {
              console.log(err.message);
            },
          });
        }
      } else {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = (e) => {
            self.front_show.images.push(e.target.result);
          };
          reader.readAsDataURL(file);

          new Compressor(file, {
            quality: 0.6,

            success(result) {
              self.post_filds.images.push(result);
            },
            error(err) {
              console.log(err.message);
            },
          });
        }
      }
      event.target.value = "";
    },
    removeImage(index) {
      this.front_show.images.splice(index, 1);
      this.post_filds.images.splice(index, 1);
    },
    setEditIndex(index) {
      this.editIndex = index;
      const input = document.getElementById("uploadImage");
      input.click();
    },
    handleDrop(event) {
      let self = this;
      const files = event.dataTransfer.files;

      const files_length = files.length + self.front_show.images.length;
      if (files_length > 8) {
        toast("شما حداکثر مجاز به بارگذاری 8 تصویر می باشید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      this.addImages(files);
    },
    addImages(files) {
      let self = this;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          self.front_show.images.push(e.target.result);
        };
        reader.readAsDataURL(file);

        new Compressor(file, {
          quality: 0.6,

          success(result) {
            self.post_filds.images.push(result);
          },
          error(err) {
            console.log(err.message);
          },
        });
      }
    },
    historyBackHandler() {
      history.back();
    },
    submitPostHandler() {
      if (!this.$store.state.auth.loggedIn) {
        toast("برای ثبت پروژه وارد حساب کاربری خود شوید.", {
          type: "error",
        });
        return;
      }
      if (
        this.$store.state.auth.loggedIn &&
        this.$store.state.auth.role != "builder"
      ) {
        toast("فقط کاربر سازنده امکان ثبت پروژه را دارد.", {
          type: "error",
        });
        return;
      }
      if (
        this.$store.state.auth.loggedIn &&
        this.$store.state.auth.role == "builder" &&
        !this.$store.state.auth.is_complate
      ) {
        toast("برای ثبت پروژه ابتدا اطلاعات پروفایل خود را تکمیل کنید.", {
          type: "error",
        });
        return;
      }
      if (
        this.$store.state.auth.loggedIn &&
        this.$store.state.auth.role == "builder" &&
        this.$store.state.auth.is_allowed == "no"
      ) {
        toast("فرایند احراز هویت شما تایید نشده است.", {
          type: "error",
        });
        return;
      }
      if (this.post_filds.content == "") {
        toast("لطفا نام پروژه خود را وارد کنید.", {
          type: "error",
        });
        return;
      }
      if (
        this.post_filds.latitude == null ||
        this.post_filds.longitude == null
      ) {
        toast("لطفا موقعیت مکانی پروژه خود را انتخاب کنید.", {
          type: "error",
        });
        return;
      }
      if (this.post_filds.status == "") {
        toast("لطفا وضعیت پروژه خود را انتخاب کنید.", {
          type: "error",
        });
        return;
      }
      if (this.front_show.images.length == 0) {
        toast("حداقل یک تصویر برای پروژه خود آپلود نمائید.", {
          type: "error",
        });
        return;
      }
      this.loading = true;
      let self = this;
      axios
        .post(
          self.$store.getters.baseUrl + "/save-builder-portfolio",
          self.post_filds,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + self.$store.getters.appToken,
            },
          }
        )
        .then((response) => {
          if (response.data.result == 1) {
            this.step = 2;
            this.post_filds = {
              category: "",
              images: [],
              details: "",
              content: "",
            };
            this.front_show = {
              images: [],
            };
            toast(response.data.msg, {
              type: "success",
            });
          } else {
            toast(response.data.msg, {
              type: "error",
            });
          }
          this.loading = false;
        });
    },
    editPostHandler() {
      if (this.post_filds.status == "") {
        toast("لطفا وضعیت پروژه خود را انتخاب کنید.", {
          type: "error",
        });
        return;
      }
      if (this.editPost && this.post_filds.images.length == 0) {
        toast("حداقل یک تصویر برای پروژه خود آپلود نمائید.", {
          type: "error",
        });
        return;
      }
      this.loading = true;
      let self = this;
      axios
        .post(
          self.$store.getters.baseUrl + "/update-builder-portfolio",
          self.post_filds,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + self.$store.getters.appToken,
            },
          }
        )
        .then((response) => {
          if (response.data.result == 1) {
            this.post_filds = {
              category: "",
              images: [],
              details: "",
              content: "",
            };
            this.front_show = {
              images: [],
            };
            toast(response.data.msg, {
              type: "success",
            });
            history.back();
          } else {
            toast(response.data.msg, {
              type: "error",
            });
          }
          this.loading = false;
        });
    },
    load_postInfo(postId) {
      let self = this;
      this.dataLoading = true;
      self.helperGet("post-info?post_id=" + postId).then((r) => {
        self.post_filds = {
          category: r.data.data.category,
          details: r.data.data.details,
          content: r.data.data.content,
          images: r.data.data.images,
          images_old: r.data.data.images_old,
          new_images: [],
        };
        self.post_filds = r.data.data;
        self.front_show.images = r.data.data.images_front;

        this.dataLoaded = true;
        this.dataLoading = false;
        this.$nextTick(() => {
          this.initMap();
        });
      });
    },
    editHandleFileChange(event) {
      let self = this;
      const files = event.target.files;

      var files_length = files.length + self.front_show.images.length;

      if (!self.front_show.images[0])
        files_length = files.length + self.front_show.images.length - 1;

      if (files_length > 8) {
        toast("شما حداکثر مجاز به بارگذاری 8 تصویر می باشید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      if (this.editIndex !== null) {
        // اگر در حال ویرایش هستیم، تصویر جدید را جایگزین تصویر قبلی می‌کنیم
        const file = files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            self.front_show.images[self.editIndex] = e.target.result; // استفاده از روش استاندارد
          };
          reader.readAsDataURL(file);

          new Compressor(file, {
            quality: 0.6,

            // The compression process is asynchronous,
            // which means you have to access the `result` in the `success` hook function.
            success(result) {
              console.log("self.editIndex", self.editIndex);
              self.post_filds.new_images[self.editIndex] = result;
              self.post_filds.images.splice(self.editIndex, 1);
              self.editIndex = null; // Reset edit index after replacing
            },
            error(err) {
              console.log(err.message);
            },
          });
        }
      } else {
        // اگر در حال اضافه کردن تصویر جدید هستیم
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = (e) => {
            self.front_show.images.push(e.target.result);
          };
          reader.readAsDataURL(file);
          console.log("ssss", self.front_show.images.length, i, files.length);
          // images Compressor
          new Compressor(file, {
            quality: 0.6,

            // The compression process is asynchronous,
            // which means you have to access the `result` in the `success` hook function.
            success(result) {
              if (files.length > 1)
                self.post_filds.new_images[
                  self.front_show.images.length - 1 + i - 1
                ] = result;

              if (files.length == 1)
                self.post_filds.new_images[self.front_show.images.length - 1] =
                  result;
            },
            error(err) {
              console.log(err.message);
            },
          });
        }
      }
      event.target.value = ""; // Reset input

      console.log(
        "qqq",
        self.post_filds.images,
        self.front_show.images,
        self.post_filds.new_images
      );
    },
    editRemoveImage(index) {
      let self = this;

      console.log(index, self.front_show.images);
      console.log(index, self.post_filds.images);
      console.log(index, self.post_filds.new_images);

      self.post_filds.images.splice(index, 1);
      self.post_filds.new_images.splice(index, 1);
      self.front_show.images.splice(index, 1);

      console.log(index, self.front_show.images);
      console.log(index, self.post_filds.images);
      console.log(index, self.post_filds.new_images);
    },
    editSetEditIndex(index) {
      this.editIndex = index; // Set the index for editing
      const input = document.getElementById("uploadImage");
      input.click(); // Open file input dialog
    },
    editHandleDrop(event) {
      const files = event.dataTransfer.files;

      const files_length = files.length + self.front_show.images.length;
      if (files_length > 8) {
        toast("شما حداکثر مجاز به بارگذاری 8 تصویر می باشید.", {
          type: "error",
          dangerouslyHTMLString: true,
        });
        return;
      }
      this.addImages(files);
    },
    editAddImages(files) {
      let self = this;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          self.front_show.images.push(e.target.result);
        };
        reader.readAsDataURL(file);

        // images Compressor
        new Compressor(file, {
          quality: 0.6,

          // The compression process is asynchronous,
          // which means you have to access the `result` in the `success` hook function.
          success(result) {
            if (files.length > 1)
              self.post_filds.new_images[
                self.front_show.images.length - 1 + i - 1
              ] = result;

            if (files.length == 1)
              self.post_filds.new_images[self.front_show.images.length - 1] =
                result;
          },
          error(err) {
            console.log(err.message);
          },
        });
      }
    },
    initMap() {
      this.isLoading = true;

      try {
        if (!document.getElementById("map")) {
          console.error("Map container not found");
          return;
        }

        if (this.map) {
          this.map.remove();
        }

        delete L.Icon.Default.prototype._getIconUrl;
        L.Icon.Default.mergeOptions({
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        });

        this.map = L.map("map", {
          center: this.defaultCenter,
          zoom: this.defaultZoom,
        });

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution: '<a href="https://abarline.ir/">Abarline</a>',
        }).addTo(this.map);

        this.marker = L.marker(this.defaultCenter, {
          draggable: false,
        }).addTo(this.map);

        this.map.on("click", this.handleMapClick);

        setTimeout(() => {
          this.map.invalidateSize();
        }, 100);
      } catch (error) {
        console.error("Error initializing map:", error);
      } finally {
        this.isLoading = false;
      }
    },

    handleMapClick(e) {
      const { lat, lng } = e.latlng;

      if (this.marker) {
        this.marker.setLatLng([lat, lng]);
      }

      this.post_filds.latitude = lat;
      this.post_filds.longitude = lng;

      // this.updateAddress(lat, lng);

      console.log(`Clicked at: ${lat}, ${lng}`);
    },

    handleMarkerDrag(event) {
      const position = event.target.getLatLng();
      this.updateAddress(position.lat, position.lng);
    },

    async updateAddress(lat, lng) {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json&accept-language=fa`
        );
        const data = await response.json();

        let persianAddress = "";

        if (data.address) {
          const addressComponents = [
            data.address.state,
            data.address.city,
            data.address.suburb,
            data.address.neighbourhood,
            data.address.road,
          ];

          const addressParts = addressComponents
            .filter((part) => part)
            .reverse();

          persianAddress = addressParts.join("، ");
        }

        if (!persianAddress) {
          persianAddress = "آدرس نامشخص";
        }

        this.post_filds.address = persianAddress;
        this.post_filds.latitude = lat;
        this.post_filds.longitude = lng;
      } catch (error) {
        console.error("Error fetching address:", error);
        this.post_filds.address = "خطا در دریافت آدرس";
      }
    },

    async searchLocation() {
      if (!this.searchQuery) return;

      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
            this.searchQuery + " بابل"
          )}&format=json&countrycodes=ir&limit=1&accept-language=fa`
        );
        const data = await response.json();

        if (data && data[0]) {
          const { lat, lon } = data[0];

          this.map.setView([lat, lon], 16);

          if (this.marker) {
            this.marker.setLatLng([lat, lon]);
          }

          this.updateAddress(lat, lon);
        } else {
          const fallbackResponse = await fetch(
            `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
              this.searchQuery
            )}&format=json&countrycodes=ir&limit=1&accept-language=fa`
          );
          const fallbackData = await fallbackResponse.json();

          if (fallbackData && fallbackData[0]) {
            const { lat, lon } = fallbackData[0];
            this.map.setView([lat, lon], 16);

            if (this.marker) {
              this.marker.setLatLng([lat, lon]);
            }

            this.updateAddress(lat, lon);
          } else {
            toast("موقعیت مورد نظر یافت نشد", {
              type: "error",
              dangerouslyHTMLString: true,
            });
          }
        }
      } catch (error) {
        console.error("Error searching location:", error);
        toast("خطا در جستجوی موقعیت", {
          type: "error",
          dangerouslyHTMLString: true,
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
    const routeId = this.$route.params.id;
    if (routeId) {
      this.editPost = true;
      this.load_postInfo(routeId);
    }
  },
};
</script>

<style scoped lang="scss">
.createPost {
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
  padding-top: 88px;
  padding-bottom: 32px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  position: fixed;
  inset: 0;
  z-index: 999;
  width: 100%;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  .createPostHeader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
    width: 100%;
    height: 64px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1);
    z-index: 9999;

    .headerContainer {
      width: 92%;
      height: 100%;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .containerTitle {
        font-size: 1.35rem !important;
        font-weight: 500;
        font-family: "iranyekanB";
      }

      .containerBackBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 70px;
        border-radius: 5px;
        background: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
        cursor: pointer;
        font-size: 1.5rem;
      }
    }
  }

  .createPostMain {
    width: 92%;
    max-width: 56rem;
    margin-left: auto;
    margin-right: auto;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),
      0 1px 2px -1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 42px 0;

    .mainContainer {
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .containerSection {
        width: 100%;

        .containerSectionSk {
          width: 100%;
          height: 240px;
          border-radius: 0.375rem;
          background: rgb(146, 221, 238);
        }

        .sectionHeader {
          margin-bottom: 12px;

          .headerTitle {
            display: flex;
            align-items: center;
            gap: 12px;
            color: #000;
            font-family: "iranyekanB", sans-serif;
            font-size: 1.1rem;
            line-height: 1.75rem;

            .titleSk {
              width: 92px;
              height: 28px;
              border-radius: 9999px;
              background: rgb(146, 221, 238);
            }

            span {
              &:first-child {
                color: #0096c7;
              }
              span {
                color: #f00 !important;
              }
            }
          }

          .headerAlert {
            color: rgb(75 85 99);
            font-size: 0.9rem;
          }
        }

        .sectionMain {
          margin-bottom: 24px;

          .formPicUploadWrapper {
            margin-bottom: 24px;

            .picUploadForm {
              width: 100%;
              padding: 48px;
              border: 2px dashed rgb(209, 213, 219);
              border-radius: 8px;
              margin-bottom: 32px;

              &:hover {
                border-color: #000;
              }

              .uploadFormContent {
                display: flex;
                flex-direction: column;
                align-items: center;

                .contentHeader {
                  margin-bottom: 10px;

                  .uploadPic {
                    color: rgb(156, 163, 175);
                    font-size: 2.25rem;
                    line-height: 2.5rem;
                  }
                }

                .contentMain {
                  margin-bottom: 10px;

                  .mainDesc {
                    font-size: 1rem;
                    line-height: 1.75rem;
                    color: rgb(17, 24, 39);
                    font-weight: 500;
                    margin-bottom: 8px;
                  }

                  .mainSubtitle {
                    color: rgb(107, 114, 128);
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                    text-align: center;
                  }
                }

                .contentFooter {
                  .uploadBtn {
                    padding: 8px 24px;
                    font-size: 0.9rem;
                    background: #0096c7;
                    color: #fff;
                    border-radius: 4px;
                    cursor: pointer;
                  }
                }
              }
            }

            .mobileUploadForm {
              display: none;
            }

            .picUploadedWrapper {
              display: grid;
              grid-template-columns: repeat(4, minmax(0, 1fr));
              gap: 24px;

              .uploadedThumb {
                width: 100%;
                overflow: hidden;
                border-radius: 8px;
                background: #fff;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

                .thumbPic {
                  width: 100%;
                  aspect-ratio: 276 / 192;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  }

                  .noUploadPic {
                    width: 100%;
                    height: 100%;
                    background: rgb(243, 244, 246);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    i {
                      color: rgb(209, 213, 219);
                      font-size: 2.25rem;
                      line-height: 2.5rem;
                      margin-bottom: 8px;
                    }

                    p {
                      color: rgb(156, 163, 175);
                      font-size: 0.8rem;
                    }
                  }
                }

                .thumbContent {
                  padding: 16px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;

                  .contentBtn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    font-size: 0.9rem;
                    cursor: pointer;

                    &.editBtn {
                      color: #0096c7;
                    }

                    &.deleteBtn {
                      color: rgb(220, 38, 38);
                    }
                  }
                }
              }
            }
          }
        }

        .sectionForm {
          width: 100%;

          .formGroup {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            width: 100%;
            height: 188px;
            border-radius: 0.375rem !important;
            border: 1px solid rgb(209, 213, 219) !important;
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
            overflow: hidden;
            margin-bottom: 16px;

            &.skeltonWrapper {
              border: none !important;
              height: auto !important;

              .inputSk {
                width: 100%;
                height: 48px;
                border-radius: 0.375rem;
                background: rgb(146, 221, 238);
              }

              .textAreaSk {
                width: 100%;
                height: 132px;
                border-radius: 0.375rem;
                background: rgb(146, 221, 238);
              }
            }

            &.categoryGroup {
              height: 50.4px !important;

              :deep(.el-select) {
                height: 100% !important;
                .el-select__wrapper {
                  min-height: auto !important;
                  height: 100% !important;
                  box-shadow: none !important;
                }
              }

              .groupTextInput {
                width: 100%;
                height: 100%;
                background: transparent;
                border: none;
                box-shadow: none;
                font-size: 1rem;
                padding: 12px;
              }
            }

            .groupTextarea {
              flex-grow: 1;
              padding: 16px;
              line-height: 24px;
              font-size: 0.9rem;
              resize: none;
            }

            .textLength {
              flex-shrink: 0;
              padding: 12px;
              color: rgb(107 114 128);
              font-size: 0.875rem;
              line-height: 1.25rem;
            }
          }

          .mapGroup {
            .leaflet-map {
              width: 100%;
              max-height: 400px !important;
              aspect-ratio: 3/2 !important;
              height: auto;
              border-radius: 0.375rem !important;
              border: 1px solid rgb(209, 213, 219) !important;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
            }

            .mapAddressInput {
              input {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                width: 100%;
                height: 50.4px !important;
                border-radius: 0.375rem !important;
                border: 1px solid rgb(209, 213, 219) !important;
                box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
                overflow: hidden;
                margin-bottom: 16px;
                font-size: 1rem;
                padding: 12px;
                margin-top: 12px;
              }
            }
          }
        }
      }

      .containerSubmitSection {
        width: 100%;
        margin-top: 32px;
        padding-top: 24px;
        border-top: 1px solid rgb(229 231 235);
        display: flex;
        align-items: center;
        justify-content: space-between;

        & > div {
          position: relative;
          width: 150px;
          height: 45px;
          border-radius: 5px;
          text-align: center;
          color: #fff;
          cursor: pointer;
          font-size: 0.9rem;
          font-family: "iranyekanB";
          transition: 0.1s ease-in-out;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;

          &.containerCancel {
            background: #f00;
          }

          &.containerSubmit {
            background: #0096c7;
          }

          .myLoader {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: inline-block;
            border-top: 3px solid #fff;
            border-right: 3px solid transparent;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
          }
        }
      }
    }

    .mainFormStep {
      &.fourthStep {
        .successedMessageWrapper {
          padding: 64px 0;

          .messageThumb {
            .thumbHeader {
              display: flex;
              justify-content: center;
              margin-bottom: 32px;

              .successedIcon {
                background: #d3ffd4;
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;

                i {
                  color: #00e004;
                  font-size: 1.5rem;
                  line-height: 2rem;
                }
              }
            }

            .thumbMain {
              margin-bottom: 32px;

              .mainTitle {
                font-size: 1.35rem;
                font-family: "iranyekanB", sans-serif;
                margin-bottom: 16px;
                text-align: center;
              }

              .mainSubtitle {
                font-size: 0.8rem;
                color: rgb(75, 85, 99);
                text-align: center;
              }
            }

            .thumbFooter {
              .footerButtonWrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;

                .footerButton  {
                  padding: 12px 32px;
                  border-radius: 12px;
                  color: #fff;
                  font-size: 0.9rem;
                  cursor: pointer;

                  &.reAddButton {
                    background: rgb(34, 197, 94);
                  }

                  &.btnShow {
                    background: #0096c7;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.dark {
  .createPost {
    background: #1e262f;

    .createPostHeader {
      background: #101a23;
      box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
        0 1px 2px -1px rgba(255, 255, 255, 0.1);
      color: #fff;

      .headerContainer {
        .containerBackBtn {
          background: #101a23;
          box-shadow: 0 0 10px rgba(255, 255, 255, 0.05);
          color: #fff;
        }
      }
    }

    .createPostMain {
      background: #101a23;
      box-shadow: 0 1px 3px 0 rgba(255, 255, 255, 0.1),
        0 1px 2px -1px rgba(255, 255, 255, 0.1);
      .mainContainer {
        .containerSection {
          .sectionHeader {
            .headerTitle {
              color: #fff;
            }
          }

          .sectionForm {
            .formGroup {
              background: #101a23 !important;
              box-shadow: 0 1px 2px 0 rgb(255, 255, 255, 0.1) !important;
              border-color: #2a3b47 !important;
              color: #fff;
              &.categoryGroup {
                :deep(.el-select) {
                  .el-select__wrapper {
                    background: transparent !important;

                    .el-select__selection {
                      .el-select__selected-item {
                        &:not(.is-transparent) {
                          span {
                            color: #fff !important;
                          }
                        }
                      }
                    }
                  }
                }
              }

              .groupTextarea {
                background: transparent !important;
                color: #fff;
              }
            }
          }

          .sectionMain {
            .formPicUploadWrapper {
              .picUploadForm {
                border: 2px dashed #2a3b47;

                .uploadFormContent {
                  .contentHeader {
                    .uploadPic {
                      color: rgb(99, 104, 112);
                    }
                  }
                  .contentMain {
                    .mainDesc {
                      color: rgb(238, 231, 221);
                    }
                  }
                }
              }

              .picUploadedWrapper {
                .uploadedThumb {
                  box-shadow: 0 1px 2px 0 rgba(255, 255, 255, 0.1);
                  background: #101a23;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1250px) {
  .createPost {
    .createPostMain {
      .mainContainer {
        .containerSection {
          .sectionMain {
            .formPicUploadWrapper {
              .picUploadedWrapper {
                grid-template-columns: repeat(3, minmax(0, 1fr));
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 950px) {
  .createPost {
    .createPostMain {
      .mainContainer {
        .containerSection {
          .sectionMain {
            .formPicUploadWrapper {
              .picUploadedWrapper {
                grid-template-columns: 1fr 1fr;

                .uploadedThumb {
                  .thumbContent {
                    .contentBtn {
                      .btnTitle {
                        display: none;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .dark {
    .createPost {
      .createPostMain {
        .mainContainer {
          .containerSubmitSection {
            background: #101a23;
          }
        }
      }
    }
  }
  .createPost {
    padding-top: 64px;
    padding-bottom: 0;
    background: #fff;
    min-height: auto;
    height: 100vh;
    overflow: hidden;

    .createPostMain {
      width: 100%;
      height: 100%;
      padding-top: 0;
      padding-bottom: 0;
      box-shadow: none;

      .mainContainer {
        padding-bottom: 0;
        height: 100%;

        .containerForm {
          height: 100%;
          overflow-y: auto;
          padding-top: 24px;
          padding-bottom: 94px;
          scrollbar-width: none;

          &::-webkit-scrollbar {
            display: none;
          }
        }
        .containerSection {
          &:last-child {
            margin-top: 24px;
          }

          .sectionHeader {
            margin-bottom: 8px;
            .headerTitle {
              font-size: 1rem;
            }
          }

          .sectionForm {
            .formGroup {
              .categoryGroup {
                :deep(.el-select) {
                  .el-select__wrapper {
                  }
                }
              }
            }
          }

          .sectionMain {
            .formPicUploadWrapper {
              .picUploadForm {
                display: none;
              }

              .mobileUploadForm {
                width: 100%;
                aspect-ratio: 1.02 / 1;
                border: 2px dashed rgb(209, 213, 219);
                border-radius: 8px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: rgb(156, 163, 175);

                .formIcon {
                  font-size: 1.125rem;
                }

                .formTitle {
                  font-size: 0.75rem;
                }
              }

              .picUploadedWrapper {
                .uploadedThumb {
                  &.noUploadedThumb {
                    display: none;
                  }
                }
              }
            }
          }
        }

        .containerSubmitSection {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          background: #fff;
          z-index: 999;
          padding: 16px;

          & > div {
            width: 124px !important;
            height: 38px;
            font-size: 0.9rem;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            cursor: pointer;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
